export function fileExtension(filename) {
  const match = filename.match(/.*\.(.*)/);
  if (!match) {
    return '';
  }
  return match[1] || '';
}
